// extracted by mini-css-extract-plugin
export default {"askQuestionTopText":"n1-z","yourQuestionLabel":"o1-z","notAuthedMessage":"p1-z","form":"q1-z","textarea":"r1-z","error":"s1-z","disabled":"t1-z","edited":"u1-z","submit":"v1-z"};